export default __webpack_public_path__ + "static/media/logom.16264166.png";